module.exports = __webpack_public_path__ + "static/two-caa30d5d59a5ea918515bf6565f91c9f.svg";